<template>
  <div>
    <Row style="margin-left:0;" type="flex" justify="space-between" >
      <Col span="12" class="changeCol">
        <Card :padding='0' dis-hover>
          <p slot="title">基础积分</p>
          <div class="jifenCard">
            <div>{{jifenRes.shimingTitle}}</div>
            <div class="cardCount">{{jifenRes.shimingScore}}分</div>
          </div>
        </Card>
      </Col>
      <Col span="12" class="changeCol">
        <Card :padding='0' dis-hover>
          <p slot="title">活动积分</p>
          <div class="jifenCard box">
            <div class="box_f1">
              <div>党员积分比例</div>
              <div class="cardCount">{{jifenRes.baifenbi?jifenRes.baifenbi:'无'}}%</div>
            </div>
            <div class="box_f1">
              <div>居民积分比例</div>
              <div class="cardCount">{{jifenRes.jumin?jifenRes.jumin:'无'}}%</div>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    props: {
      jifenRes:Object
    },
    components: {
    },
  }
</script>

<style scoped>
  .changeCol{
    padding: 0 10px 30px 10px
  }
  .jifenCard{
    padding:16px;
  }
  .cardCount{
    font-size:18px;
    color: #ff7b44;
    margin-top:30px
  }
</style>
